import React from 'react';
import { withFirebase } from '../../../../../../../hoc';
import OrderCallHistory from '../../../../../../../components/sections/OrderCallHistory';

const CallAndChatHistory = ({ orderId, firebase, isWhatsapp, picker, client }) => {
    return <OrderCallHistory
        callHistoryType='shopper_calls'
        orderId={orderId}
        firebase={firebase}
        isWhatsapp={isWhatsapp}
        isAudit
        picker={picker}
        client={client}
    />
};

export default withFirebase(CallAndChatHistory);